import { FC, useState, useEffect, useRef, useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@store/auth/AuthProvider'
import { searchAll, type SearchEntry } from '@utils/searchIndex'
import { openPdfViewer } from '@utils/pdfViewer'
import { cn } from '@utils/index'
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@components/ui/dialog'
import {
  Search,
  LayoutGrid,
  Layers,
  Box,
  CornerDownLeft,
  ArrowRight,
  BarChart3,
  Command,
  FolderOpen,
  CalendarClock,
  Truck,
  Megaphone,
} from 'lucide-react'

const menuItemsForSearch = [
  { path: '/', label: 'Inicio', icon: LayoutGrid, permission: null },
  { path: '/buscar-cubeta', label: 'Buscar Cubeta', icon: Search, permission: 'aalbaranes' },
  { path: '/documentos', label: 'Documentos', icon: FolderOpen, permission: 'afacturas' },
  {
    path: '/attendance',
    label: 'Asistencia Remota',
    icon: Layers,
    permission: 'apedidos',
    children: [
      { path: '/attendance/security-code', label: 'Código seguridad', icon: Layers, permission: 'apedidos' },
      { path: '/attendance/downloads', label: 'Descargar', icon: Search, permission: 'apedidos' },
    ]
  },
  {
    path: '/mifarmacia',
    label: 'MiFarmacia',
    icon: LayoutGrid,
    permission: null,
    children: [
      { path: '/orders', label: 'Pedidos', icon: Search, permission: 'apedidos' },
      {
        path: '/transfers',
        label: 'Transfer',
        icon: ArrowRight,
        permission: 'atransferfacil',
        children: [
          { path: '/transfers/gestion', label: 'Gestión Transfer', icon: BarChart3, permission: 'atransferfacil' },
          { path: '/transfers/facil', label: 'Transfer Fácil', icon: ArrowRight, permission: 'atransferfacil' },
          { path: '/transfers/facil-agrupado', label: 'Transfer Fácil (Agrupado)', icon: ArrowRight, permission: 'atransferfacil' },
          { path: '/transfers/grupo', label: 'Transfer Grupo', icon: ArrowRight, permission: 'atransfergestion' },
          { path: '/transfers/grupo-agrupado', label: 'Transfer Grupo (Agrupado)', icon: ArrowRight, permission: 'atransfergestion' },
        ]
      },
      { path: '/delivery-notes', label: 'Albaranes', icon: Layers, permission: 'aalbaranes' },
      { path: '/albaranes-vencimiento', label: 'Albaranes Vencimiento', icon: CalendarClock, permission: 'aalbaranes' },
      { path: '/delivery-notes/contrast', label: 'Contrastar albaranes', icon: Layers, permission: 'aalbaranes' },
      { path: '/recepcion', label: 'Recepción', icon: Layers, permission: 'aalbaranes' },
      {
        path: '/estupefacientes',
        label: 'Estupefacientes',
        icon: Layers,
        permission: 'aestupe',
        children: [
          { path: '/estupefacientes/pedidos', label: 'Pedidos Estupefacientes', icon: Layers, permission: 'aestupe' },
          { path: '/estupefacientes/informe-resumen', label: 'Informe Resumen', icon: Layers, permission: 'afacturas' },
          { path: '/estupefacientes/informe-detallado', label: 'Informe Detallado', icon: Layers, permission: 'afacturas' },
        ]
      },
      { path: '/aviso-disponibilidad', label: 'Aviso Disponibilidad', icon: Layers, permission: 'adisponibilidad' },
      { path: '/sms', label: 'Envío SMS', icon: Layers, permission: 'asms' },
      { path: '/partial-deliveries', label: 'Entregas Parciales', icon: Layers, permission: 'aentregas' },
      {
        path: '/facturacion',
        label: 'Facturación',
        icon: Layers,
        permission: 'afacturas',
        children: [
          { path: '/invoices', label: 'Facturas', icon: Layers, permission: 'afacturas' },
          { path: '/invoices/calendar', label: 'Calendario vencimientos', icon: Layers, permission: 'afacturas' },
          { path: '/invoices/pending-due', label: 'Pte.Vencimiento', icon: Layers, permission: 'afacturas' },
          { path: '/aportaciones', label: 'Aportaciones', icon: Layers, permission: 'afacturas' },
          { path: '/condiciones', label: 'Condiciones grupo facturación', icon: Layers, permission: 'afacturas' },
        ]
      },
      {
        path: '/logistica-inversa',
        label: 'Logística inversa',
        icon: Layers,
        permission: 'adevolucion',
        children: [
          { path: '/devoluciones', label: 'Caducidad y retirada', icon: Layers, permission: 'adevolucion' },
          { path: '/devoluciones-ds', label: 'Devoluciones y DS', icon: Layers, permission: 'adevolucion' },
          { path: '/cedifa', label: 'CEDIFA', icon: Layers, permission: null },
        ]
      },
      {
        path: '/informes-compras',
        label: 'Informes Compras',
        icon: Layers,
        permission: 'afacturas',
        children: [
          { path: '/informes-compras/tramo', label: 'Tramo', icon: Layers, permission: 'afacturas' },
          { path: '/informes-compras/nivel-acofarma', label: 'Nivel ACOFARMA', icon: Layers, permission: 'afacturas' },
          { path: '/informes-compras/histo-compras', label: 'Histo compras', icon: Layers, permission: 'afacturas' },
          { path: '/informes-compras/categorias', label: 'Categorías', icon: Layers, permission: 'afacturas' },
          { path: '/informes-compras/vet-antibioticos', label: 'Vet. antibióticos', icon: Layers, permission: 'afacturas' },
        ]
      },
      {
        path: '/analisis-datos',
        label: 'Análisis de datos',
        icon: Layers,
        permission: 'abi',
        children: [
          { path: '/analisis-datos/logistica-inversa', label: 'Logística inversa', icon: Layers, permission: 'abi' },
          { path: '/analisis-datos/compras', label: 'Compras', icon: Layers, permission: 'abi' },
          { path: '/analisis-datos/estupefacientes', label: 'Estupefacientes', icon: Layers, permission: 'abi' },
        ]
      },
    ]
  },
  {
    path: '/micooperativa',
    label: 'MiCooperativa',
    icon: LayoutGrid,
    permission: null,
    children: [
      { path: '/encargos', label: 'Encargos', icon: Layers, permission: 'aencargos' },
      { path: '#seguimiento-envios', label: 'Seguimiento envíos', icon: Truck, permission: null, modalPdf: { title: 'Seguimiento envíos', src: '/SeguimientoEnvios.pdf' } },
      { path: '/altas', label: 'Nuevas altas', icon: Layers, permission: 'aconsulta' },
    ]
  },
  {
    path: '/dpto-informatica',
    label: 'Dpto. Informática',
    icon: LayoutGrid,
    permission: null,
    children: [
      { path: '/farmaturn', label: 'FarmaTurn', icon: Layers, permission: 'amiunycop' },
      { path: '/consumibles', label: 'Pedidos Consumibles', icon: Layers, permission: null },
      { path: '/incidencias', label: 'Notificar Incidencia', icon: Layers, permission: null },
    ]
  },
  { path: '/cambios', label: 'Novedades', icon: Megaphone, permission: null },
  { path: '/users', label: 'Gestión de Usuarios', icon: Layers, permission: 'ausuarios' },
  { path: '/profile', label: 'Mi Perfil', icon: Layers, permission: null },
]

function highlightMatch(text: string, query: string): React.ReactNode {
  if (!query.trim()) return text

  const normalizedText = text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  const normalizedQuery = query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  const index = normalizedText.indexOf(normalizedQuery)

  if (index === -1) return text

  return (
    <>
      {text.slice(0, index)}
      <span className="font-bold text-cofarte-purple">
        {text.slice(index, index + query.length)}
      </span>
      {text.slice(index + query.length)}
    </>
  )
}

function getTypeBadge(type: SearchEntry['type']): { label: string; className: string } {
  switch (type) {
    case 'menu':
      return { label: 'Menú', className: 'bg-cofarte-purple/10 text-cofarte-purple' }
    case 'widget':
      return { label: 'Widget', className: 'bg-blue-50 text-blue-600' }
    case 'page-section':
    default:
      return { label: 'Sección', className: 'bg-gray-100 text-gray-600' }
  }
}

export const GlobalSearch: FC = () => {
  const [open, setOpen] = useState(false)
  const [query, setQuery] = useState('')
  const [selectedIndex, setSelectedIndex] = useState(0)
  const { permissions } = useAuth()
  const navigate = useNavigate()
  const inputRef = useRef<HTMLInputElement>(null)
  const listRef = useRef<HTMLDivElement>(null)
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const [debouncedQuery, setDebouncedQuery] = useState('')

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => {
      setDebouncedQuery(query)
    }, 150)
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current)
    }
  }, [query])

  const results = useMemo(() => {
    return searchAll(debouncedQuery, permissions, menuItemsForSearch)
  }, [debouncedQuery, permissions])

  useEffect(() => {
    setSelectedIndex(0)
  }, [debouncedQuery])

  useEffect(() => {
    if (results.length === 0) return
    setSelectedIndex(prev => Math.min(prev, results.length - 1))
  }, [results.length])

  const handleSelect = useCallback((entry: SearchEntry) => {
    setOpen(false)
    setQuery('')
    setDebouncedQuery('')
    if (entry.modalPdf) {
      openPdfViewer(entry.modalPdf)
      return
    }
    navigate(entry.path)
  }, [navigate])

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault()
        setOpen(prev => !prev)
      }
    }
    const handleOpenSearch = () => setOpen(prev => !prev)
    window.addEventListener('keydown', handleKeyDown)
    window.addEventListener('open-global-search', handleOpenSearch)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('open-global-search', handleOpenSearch)
    }
  }, [])

  useEffect(() => {
    if (!open) return
    const timer = setTimeout(() => inputRef.current?.focus(), 50)
    return () => clearTimeout(timer)
  }, [open])

  useEffect(() => {
    if (!open) {
      setQuery('')
      setDebouncedQuery('')
      setSelectedIndex(0)
    }
  }, [open])

  useEffect(() => {
    const selectedEl = listRef.current?.querySelector('[data-selected="true"]')
    if (selectedEl) {
      selectedEl.scrollIntoView({ block: 'nearest' })
    }
  }, [selectedIndex])

  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      setSelectedIndex(prev => (prev + 1) % results.length)
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      setSelectedIndex(prev => (prev - 1 + results.length) % results.length)
    } else if (e.key === 'Enter') {
      e.preventDefault()
      if (results[selectedIndex]) {
        handleSelect(results[selectedIndex])
      }
    } else if (e.key === 'Escape') {
      setOpen(false)
    }
  }, [results, selectedIndex, handleSelect])

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="p-0 gap-0 max-w-xl overflow-hidden">
        <DialogTitle className="sr-only">Búsqueda global</DialogTitle>

        <div className="flex items-center border-b border-gray-200 px-4">
          <Search className="h-5 w-5 text-gray-400 shrink-0" />
          <input
            ref={inputRef}
            type="text"
            className="flex-1 h-12 px-3 bg-transparent text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none"
            placeholder="Buscar menús, páginas, secciones..."
            value={query}
            onChange={e => setQuery(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          {query && (
            <button
              onClick={() => { setQuery(''); setDebouncedQuery(''); inputRef.current?.focus() }}
              className="text-xs text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded hover:bg-gray-200 transition-colors"
            >
              Esc
            </button>
          )}
        </div>

        <div
          ref={listRef}
          className="max-h-[400px] overflow-y-auto"
          role="listbox"
        >
          {results.length === 0 && debouncedQuery && (
            <div className="px-4 py-12 text-center">
              <Search className="h-8 w-8 text-gray-300 mx-auto mb-3" />
              <p className="text-sm text-gray-500">
                No se encontraron resultados para &quot;<span className="font-medium text-gray-700">{debouncedQuery}</span>&quot;
              </p>
              <p className="text-xs text-gray-400 mt-1">
                Prueba con otros términos o revisa el menú lateral
              </p>
            </div>
          )}

          {results.length > 0 && (
            <div className="py-2">
              {results.map((entry, index) => {
                const badge = getTypeBadge(entry.type)
                const isSelected = index === selectedIndex
                const Icon = entry.icon

                return (
                  <button
                    key={`${entry.path}-${entry.label}-${entry.type}`}
                    role="option"
                    aria-selected={isSelected}
                    data-selected={isSelected}
                    className={cn(
                      'w-full flex items-center gap-3 px-4 py-2.5 text-left transition-colors cursor-pointer',
                      isSelected
                        ? 'bg-cofarte-purple/5 border-l-2 border-cofarte-purple'
                        : 'border-l-2 border-transparent hover:bg-gray-50'
                    )}
                    onClick={() => handleSelect(entry)}
                    onMouseEnter={() => setSelectedIndex(index)}
                  >
                    <div className={cn(
                      'flex items-center justify-center w-8 h-8 rounded-lg shrink-0',
                      isSelected
                        ? 'bg-cofarte-purple/10 text-cofarte-purple'
                        : 'bg-gray-100 text-gray-400'
                    )}>
                      {Icon ? <Icon className="h-4 w-4" /> : <Box className="h-4 w-4" />}
                    </div>

                    <div className="flex-1 min-w-0">
                      <div className="text-sm text-gray-900 truncate">
                        {highlightMatch(entry.label, debouncedQuery)}
                      </div>
                      <div className="text-xs text-gray-400 truncate mt-0.5">
                        {entry.breadcrumb}
                      </div>
                    </div>

                    <span className={cn(
                      'text-[10px] font-medium px-1.5 py-0.5 rounded-full shrink-0',
                      badge.className
                    )}>
                      {badge.label}
                    </span>

                    {isSelected && (
                      <CornerDownLeft className="h-3.5 w-3.5 text-gray-400 shrink-0" />
                    )}
                  </button>
                )
              })}
            </div>
          )}
        </div>

        <div className="flex items-center justify-between border-t border-gray-100 px-4 py-2.5 text-[11px] text-gray-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <kbd className="inline-flex items-center h-4 px-1 rounded bg-gray-100 font-mono text-[10px]">↑↓</kbd>
              <span>Navegar</span>
            </span>
            <span className="flex items-center gap-1">
              <kbd className="inline-flex items-center h-4 px-1 rounded bg-gray-100 font-mono text-[10px]">↵</kbd>
              <span>Abrir</span>
            </span>
            <span className="flex items-center gap-1">
              <kbd className="inline-flex items-center h-4 px-1 rounded bg-gray-100 font-mono text-[10px]">Esc</kbd>
              <span>Cerrar</span>
            </span>
          </div>
          <span className="flex items-center gap-1">
            <Command className="h-3 w-3" />
            <span>K</span>
          </span>
        </div>
      </DialogContent>
    </Dialog>
  )
}
